// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2K9pI","label":"SetPasswdForm_label__2I4Ud"};